import { render, staticRenderFns } from "./AppTabs.vue?vue&type=template&id=3a586ab9&scoped=true&"
import script from "./AppTabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppTabs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AppTabs.vue?vue&type=style&index=0&id=3a586ab9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a586ab9",
  null
  
)

export default component.exports